var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 7.49996V5.83329C13 5.39127 12.842 4.96734 12.5606 4.65478C12.2793 4.34222 11.8978 4.16663 11.5 4.16663H8.5C8.10218 4.16663 7.72064 4.34222 7.43934 4.65478C7.15803 4.96734 7 5.39127 7 5.83329V6.66663C7 6.92537 7.05422 7.18056 7.15836 7.41198C7.2625 7.64341 7.41371 7.84472 7.6 7.99996L12.4 12C12.5863 12.1552 12.7375 12.3565 12.8417 12.588C12.9458 12.8194 13 13.0745 13 13.3333V14.1666C13 14.6086 12.842 15.0325 12.5606 15.3451C12.2793 15.6577 11.8978 15.8333 11.5 15.8333H8.5C8.10218 15.8333 7.72064 15.6577 7.43934 15.3451C7.15803 15.0325 7 14.6086 7 14.1666V12.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.5V17.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToken);
export default __webpack_public_path__ + "static/media/token.1d4bb0b567fc151212307fde51a058b9.svg";
export { ForwardRef as ReactComponent };